import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/video/MVP-Comm-Website-Update-031925-4.mp4")